/* CARE — Buy box V2 (abonnement-first) : plans, sticky bar, top bar, people, modal */
(function(){
  function init(){
    var root = document.querySelector('.care-pv2');
    if(!root) return;
    var plans = root.querySelectorAll('.care-pv2__plan');
    var isV3 = !!root.querySelector('[data-pv3]');
    var form = root.querySelector('form');
    var spInput = root.querySelector('[data-care-selling-plan]');
    var sName = document.getElementById('pv2-sticky-name');
    var sDay = document.getElementById('pv2-sticky-day');
    var sSel = document.getElementById('pv2-sticky-sel');
    var sMenu = document.getElementById('pv2-sticky-menu');
    var qtyInput = root.querySelector('[data-care-qty]');
    var people = 1;
    function currentQtyBase(){ var act = root.querySelector('.care-pv2__plan.is-active'); return act ? (parseInt(act.getAttribute('data-qty'),10) || 1) : 1; }
    function updateQty(){ if(qtyInput){ qtyInput.value = currentQtyBase() * (people || 1); } }

    function planData(p){
      var s = p.querySelector('.care-pv2__save');
      var d = p.querySelector('.care-pv2__serv');
      return {
        plan: p.getAttribute('data-plan'),
        name: (p.querySelector('.care-pv2__planname')||{}).textContent.trim(),
        save: s ? s.textContent.trim() : '',
        day: d ? d.textContent.trim() : '',
        planId: p.getAttribute('data-plan-id') || ''
      };
    }
    function updateAtc(){
      var atcB = root.querySelector('.care-pv2__atc'); if(!atcB || !atcB.getAttribute('data-atc-tmpl')) return;
      var act = root.querySelector('.care-pv2__plan.is-active');
      var badge = act ? act.querySelector('.care-pv2__save') : null;
      var save = badge ? badge.textContent.trim() : '';
      var sav = save ? ' · ' + save : '';
      atcB.textContent = atcB.getAttribute('data-atc-tmpl').replace(/\[save\]/g, sav);
    }
    function syncSticky(){
      var act = root.querySelector('.care-pv2__plan.is-active'); if(!act) return;
      updateAtc();
      var dt = planData(act);
      if(sName) sName.textContent = dt.name + (dt.save ? ' (' + dt.save + ')' : '');
      if(sDay) sDay.textContent = dt.day;
      if(sMenu) sMenu.querySelectorAll('.care-pv2__stickyopt').forEach(function(o){ o.classList.toggle('is-active', o.getAttribute('data-plan') === dt.plan); });
      if(spInput){
        if(dt.planId){ spInput.value = dt.planId; spInput.removeAttribute('disabled'); }
        else { spInput.value = ''; spInput.setAttribute('disabled','disabled'); }
      }
      updateQty();
    }
    function selectPlan(dp){
      plans.forEach(function(x){ var on = x.getAttribute('data-plan') === dp; x.classList.toggle('is-active', on); var i = x.querySelector('input[type=radio]'); if(i) i.checked = on; });
      syncSticky();
    }
    plans.forEach(function(p){ p.addEventListener('click', function(){ selectPlan(p.getAttribute('data-plan')); }); });
    syncSticky();

    // coffret cadeaux : bannière repliable
    root.addEventListener('click', function(e){
      var h = e.target.closest('.care-pv2__kit2head');
      if(h){ e.preventDefault(); e.stopPropagation(); var box = h.closest('.care-pv2__kit2'); if(box) box.classList.toggle('is-open'); return; }
      var a = e.target.closest('.care-pv2__accsum');
      if(a){ var it = a.closest('.care-pv2__accitem'); if(it) it.classList.toggle('is-open'); }
    });

    // dropdown menu de la barre sticky (V2 uniquement ; en V3 c'est un simple label)
    if(sSel && sMenu && !isV3){
      sSel.addEventListener('click', function(e){ e.stopPropagation(); var willOpen = sMenu.hidden; sMenu.hidden = !willOpen; sSel.classList.toggle('is-open', willOpen); });
      sMenu.querySelectorAll('.care-pv2__stickyopt').forEach(function(o){ o.addEventListener('click', function(){ selectPlan(o.getAttribute('data-plan')); sMenu.hidden = true; sSel.classList.remove('is-open'); }); });
      document.addEventListener('click', function(e){ if(!sMenu.hidden && !sMenu.contains(e.target) && !sSel.contains(e.target)){ sMenu.hidden = true; sSel.classList.remove('is-open'); } });
    }

    // galerie : slider swipeable synchronisé avec les miniatures
    var track = root.querySelector('.care-pv2__track');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.care-pv2__thumb'));
    if(track && thumbs.length){
      track.innerHTML = '';
      thumbs.forEach(function(t){
        var src = t.getAttribute('data-src'); if(!src) return;
        var slide = document.createElement('div');
        slide.className = 'care-pv2__slide';
        var img = document.createElement('img');
        img.src = src; img.alt = ''; img.setAttribute('loading','lazy');
        slide.appendChild(img); track.appendChild(slide);
      });
      var setActive = function(i){
        thumbs.forEach(function(x,j){ x.classList.toggle('is-active', j===i); });
        // garde la miniature active visible dans le rail quand on swipe l'image principale
        var t = thumbs[i], rail = t && t.parentElement;
        if(t && rail && rail.scrollWidth - rail.clientWidth > 4){
          rail.scrollTo({ left: Math.max(0, t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
        }
      };
      thumbs.forEach(function(t,i){
        t.addEventListener('click', function(){
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          setActive(i);
        });
      });
      var st;
      track.addEventListener('scroll', function(){
        clearTimeout(st);
        st = setTimeout(function(){
          var i = Math.round(track.scrollLeft / track.clientWidth);
          i = Math.max(0, Math.min(thumbs.length - 1, i));
          setActive(i);
        }, 60);
      }, { passive: true });
    }

    // miniatures : flèches de défilement (masquées s'il n'y a rien à faire défiler)
    var trail = root.querySelector('[data-pv2-thumbs]');
    var tprev = root.querySelector('[data-pv2-tprev]');
    var tnext = root.querySelector('[data-pv2-tnext]');
    if(trail && tprev && tnext){
      var syncNav = function(){
        var over = trail.scrollWidth - trail.clientWidth;
        var scrollable = over > 4;
        tprev.hidden = !scrollable;
        tnext.hidden = !scrollable;
        if(!scrollable) return;
        tprev.disabled = trail.scrollLeft <= 2;
        tnext.disabled = trail.scrollLeft >= over - 2;
      };
      // cible courante : sans elle, deux clics rapides se remplacent au lieu de s'additionner
      var tgoal = null;
      var step = function(dir){
        var first = trail.querySelector('.care-pv2__thumb');
        var w = first ? first.getBoundingClientRect().width + 10 : 90;
        var max = trail.scrollWidth - trail.clientWidth;
        var base = (tgoal === null) ? trail.scrollLeft : tgoal;
        // avance de 3 miniatures : assez rapide sans perdre le repère visuel
        tgoal = Math.max(0, Math.min(max, base + dir * w * 3));
        trail.scrollTo({ left: tgoal, behavior: 'smooth' });
      };
      ['wheel','touchstart','pointerdown'].forEach(function(ev){
        trail.addEventListener(ev, function(){ tgoal = null; }, { passive: true });
      });
      tprev.addEventListener('click', function(){ step(-1); });
      tnext.addEventListener('click', function(){ step(1); });
      trail.addEventListener('scroll', syncNav, { passive: true });
      window.addEventListener('resize', syncNav);
      syncNav();
      // les images pèsent sur la largeur du rail : on resynchronise une fois chargées
      window.addEventListener('load', syncNav);
    }

    // curseur "nombre de personnes" (gamifié)
    var slider = root.querySelector('.care-pv2__pslider');
    if(slider){
      var ptrack = slider.querySelector('.care-pv2__ptrack');
      var pfill = slider.querySelector('.care-pv2__pfill');
      var pthumb = slider.querySelector('.care-pv2__pthumb');
      var pthumbNum = pthumb ? pthumb.querySelector('span') : null;
      var pdisc = root.querySelector('.care-pv2__pdisc');
      var PDISC = { '1': slider.getAttribute('data-d1')||'Prix de base', '2': slider.getAttribute('data-d2')||'−5% en plus', '3': slider.getAttribute('data-d3')||'−10% en plus' };
      var pcur = 0;
      function setPeople(v, animate){
        v = Math.max(1, Math.min(3, v));
        var pct = (v-1)/2*100;
        if(pfill) pfill.style.width = pct+'%';
        if(pthumb) pthumb.style.left = pct+'%';
        if(pthumbNum) pthumbNum.textContent = v;
        if(pdisc){ pdisc.textContent = PDISC[v]; pdisc.classList.toggle('is-save', v>1); if(animate && v!==pcur){ pdisc.classList.remove('pop'); void pdisc.offsetWidth; pdisc.classList.add('pop'); } }
        slider.setAttribute('data-value', v);
        root.querySelectorAll('.care-pv2__pnode,.care-pv2__pcol').forEach(function(el){ el.classList.toggle('is-on', +el.getAttribute('data-people')===v); });
        pcur = v;
        people = v;
        updateQty();
      }
      function pvFromX(x){ var r=ptrack.getBoundingClientRect(); var p=(x-r.left)/r.width; return Math.round(Math.max(0,Math.min(1,p))*2)+1; }
      var pdrag=false;
      function pdown(e){ pdrag=true; slider.classList.add('is-dragging'); var x=e.touches?e.touches[0].clientX:e.clientX; setPeople(pvFromX(x), true); if(e.cancelable) e.preventDefault(); }
      function pmove(e){ if(!pdrag) return; var x=e.touches?e.touches[0].clientX:e.clientX; setPeople(pvFromX(x), true); if(e.cancelable) e.preventDefault(); }
      function pup(){ if(!pdrag) return; pdrag=false; slider.classList.remove('is-dragging'); }
      slider.addEventListener('mousedown', pdown); slider.addEventListener('touchstart', pdown, {passive:false});
      document.addEventListener('mousemove', pmove); document.addEventListener('touchmove', pmove, {passive:false});
      document.addEventListener('mouseup', pup); document.addEventListener('touchend', pup);
      root.querySelectorAll('.care-pv2__pcol').forEach(function(c){ c.addEventListener('click', function(){ setPeople(+c.getAttribute('data-people'), true); }); });
      setPeople(1, false);
    }

    // cross-sell / lot (recalcul prix/jour + ajout au panier)
    var xs = root.querySelector('.care-pv2xsell');
    if(xs){
      var xItems = [].slice.call(xs.querySelectorAll('.care-pv2xsell__item'));
      var xDay = xs.querySelector('[data-pv2xs-day]'), xWas = xs.querySelector('[data-pv2xs-was]'), xNow = xs.querySelector('[data-pv2xs-now]'), xSave = xs.querySelector('[data-pv2xs-save]'), xAdd = xs.querySelector('[data-pv2xs-add]');
      var xDisc = (parseFloat(xs.getAttribute('data-discount'))||0)/100;
      var xDays = parseInt(xs.getAttribute('data-days'),10)||30;
      function xfmt(n){ return Math.round(n)+'€'; }
      function xfmtDay(n){ return (n/xDays).toFixed(2).replace('.',',')+'€'; }
      function xrc(){
        var sel = xItems.filter(function(i){ return i.classList.contains('is-on'); });
        var raw = sel.reduce(function(s,i){ return s+(parseFloat(i.getAttribute('data-price'))||0); },0);
        var d = sel.length>=2 && xDisc>0;
        var now = d ? raw*(1-xDisc) : raw;
        if(xDay) xDay.textContent = xfmtDay(now);
        if(xNow) xNow.textContent = xfmt(now);
        if(xWas){ xWas.hidden = !d; if(d) xWas.textContent = xfmt(raw); }
        if(xSave){ xSave.hidden = !d; if(d) xSave.textContent = 'Économisez ' + xfmt(raw-now); }
      }
      xItems.forEach(function(it){ var cb=it.querySelector('input'); if(!cb) return; cb.addEventListener('change', function(){ it.classList.toggle('is-on', cb.checked); xrc(); }); });
      if(xAdd){ xAdd.addEventListener('click', function(){
        var payload = xItems.filter(function(i){ return i.classList.contains('is-on'); }).map(function(i){ return { id: i.getAttribute('data-variant-id'), quantity: 1 }; }).filter(function(x){ return x.id; });
        if(!payload.length) return;
        xAdd.disabled = true;
        if (window.CareCart && window.CareCart.addItems) {
          window.CareCart.addItems(payload);
          setTimeout(function(){ xAdd.disabled = false; }, 800);
        } else {
          fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: payload }) })
            .then(function(r){ return r.json(); }).then(function(){ window.location.href = '/cart'; }).catch(function(){ xAdd.disabled = false; });
        }
      }); }
      xrc();
    }

    // modal étiquette nutritionnelle
    var mBtn = root.querySelector('[data-pv2-nutri]');
    var modal = document.getElementById('pv2-nutri-modal');
    if(mBtn && modal){
      function closeM(){ modal.hidden = true; document.body.style.overflow = ''; }
      mBtn.addEventListener('click', function(){ modal.hidden = false; document.body.style.overflow = 'hidden'; });
      var cl = modal.querySelector('.care-pv2modal__close'); if(cl) cl.addEventListener('click', closeM);
      modal.addEventListener('click', function(e){ if(e.target === modal) closeM(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !modal.hidden) closeM(); });
    }

    // barre sticky bas : visible quand le bouton principal sort de l'écran
    var atc = root.querySelector('.care-pv3__atc, .care-pv2__atc');
    var bar = document.getElementById('pv2-sticky');
    if(isV3 && bar){ bar.classList.add('care-pv2__stickybar--v3'); }
    if(atc && bar && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          // le sticky s'affiche une fois la buy box DÉPASSÉE (ATC passé au-dessus de l'écran)
          var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
        });
      }, {threshold:0, rootMargin:'0px 0px -60px 0px'});
      io.observe(atc);

      // …mais elle s'efface dès que le pied de page entre à l'écran, sinon elle le recouvre.
      var foot = document.querySelector('.care-foot');
      if(foot){
        var ioFoot = new IntersectionObserver(function(entries){
          entries.forEach(function(en){ bar.classList.toggle('is-atfoot', en.isIntersecting); });
        }, {threshold:0});
        ioFoot.observe(foot);
      }
    }
    var sBtn = document.getElementById('pv2-sticky-btn');
    if(sBtn && atc && !isV3){ sBtn.addEventListener('click', function(){ atc.click(); }); }

    // modal vidéo ambassadeur
    var vModal = document.getElementById('pv2-video-modal');
    var vSlot = document.getElementById('pv2-video-slot');
    if(vModal && vSlot){
      function closeV(){ vModal.hidden = true; vSlot.innerHTML = ''; document.body.style.overflow = ''; }
      function embedFor(url){
        var yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
        if(yt){ return '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1" allow="autoplay; encrypted-media; fullscreen" allowfullscreen frameborder="0"></iframe>'; }
        var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if(vm){ return '<iframe src="https://player.vimeo.com/video/' + vm[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen frameborder="0"></iframe>'; }
        return '<video src="' + url + '" controls autoplay playsinline></video>';
      }
      root.querySelectorAll('.care-pv2__ambcard[data-pv2-video]').forEach(function(c){
        c.addEventListener('click', function(){
          var url = c.getAttribute('data-pv2-video'); if(!url) return;
          vSlot.innerHTML = embedFor(url); vModal.hidden = false; document.body.style.overflow = 'hidden';
        });
      });
      var vcl = vModal.querySelector('.care-pv2modal__close'); if(vcl) vcl.addEventListener('click', closeV);
      vModal.addEventListener('click', function(e){ if(e.target === vModal) closeV(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !vModal.hidden) closeV(); });
    }

    // top bar promo : désactivée (on ne garde que le sticky CTA du bas)
    var topbar = document.getElementById('pv2-topbar');
    if(topbar){ topbar.classList.remove('is-visible'); topbar.style.display = 'none'; }
  }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* CARE — Buy box V3 : pricing durée + mode (branché selling plans) */
(function(){
  function initV3(){
    document.querySelectorAll('[data-pv3]').forEach(function(root){
      if(root.__pv3) return; root.__pv3 = true;
      var form = root.closest('form');
      var spInput = form ? form.querySelector('[data-care-selling-plan]') : null;
      var qtyInput = form ? form.querySelector('[data-care-qty]') : null;
      var durs = root.querySelectorAll('.care-pv3__dur');
      var modes = root.querySelectorAll('.care-pv3__mode');
      var atc = root.querySelector('[data-pv3-atc]');
      var ship = root.querySelector('[data-pv3-ship]');
      var kit = root.querySelector('[data-kit]');
      var kithead = root.querySelector('[data-kithead]');
      var kittitle = root.querySelector('[data-kittitle]');
      var kitsub = root.querySelector('[data-kitsub]');
      var kitcta = root.querySelector('[data-kitcta]');
      var dur = 30, mode = 'once', lastMode = null;
      var shipSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 17V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h1"/><path d="M14 8h4l4 4v5a1 1 0 0 1-1 1h-1"/><path d="M9 18h5"/><circle cx="6.5" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>';
      var chev = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
      var atcBase = (atc ? atc.textContent.trim() : 'Je démarre ma cure');
      function eur(c){ return (c/100).toFixed(2).replace('.',',') + '€'; }
      function pd(total,days){ return (total/days/100).toFixed(2).replace('.',',') + '€'; }
      function cur(){ return root.querySelector('.care-pv3__dur[data-dur="'+dur+'"]'); }
      function mlabel(days){ return Math.round(days/30)+' mois'; }
      // Livraison à J+2 ouvrés (date de Paris), hors week-ends et jours fériés français.
      function easter(y){ var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),x=h+l-7*m+114; return new Date(y,Math.floor(x/31)-1,x%31+1); }
      function holiday(d){
        var y=d.getFullYear(), e=easter(y);
        if(['1-1','5-1','5-8','7-14','8-15','11-1','11-11','12-25'].indexOf((d.getMonth()+1)+'-'+d.getDate())>-1) return true;
        return [1,39,50].some(function(n){ var x=new Date(y,e.getMonth(),e.getDate()+n); return x.getMonth()===d.getMonth() && x.getDate()===d.getDate(); });
      }
      function delivLabel(){
        var p = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date()).split('-');
        var d = new Date(+p[0], p[1]-1, +p[2]), n = 0;
        while(n < 2){ d.setDate(d.getDate()+1); if(d.getDay()!==0 && d.getDay()!==6 && !holiday(d)) n++; }
        return d.toLocaleDateString('fr-FR',{weekday:'long',day:'numeric',month:'long'});
      }
      function render(){
        var isSubMode = mode === 'sub';
        durs.forEach(function(el){
          var days=+el.getAttribute('data-days'), sub=+el.getAttribute('data-sub'), once=+el.getAttribute('data-once');
          var disc = once>0 ? Math.round((once-sub)/once*100) : 0;
          // La carte montre toujours le prix mensuel en abonnement, même quand l'achat unique est coché.
          var pdEl=el.querySelector('[data-pd]'); if(pdEl) pdEl.innerHTML = eur(Math.round(sub/(days/30)))+'<small> /mois</small>';
          var b=el.querySelector('[data-badge]'); if(b){ if(isSubMode && disc>0){ b.textContent='−'+disc+'%'; b.style.display=''; } else { b.style.display='none'; } }
          el.classList.toggle('is-on', +el.getAttribute('data-dur')===dur);
        });
        var c=cur(); if(!c) return;
        var days=+c.getAttribute('data-days'), sub=+c.getAttribute('data-sub'), once=+c.getAttribute('data-once');
        var plan=c.getAttribute('data-plan'), qty=+c.getAttribute('data-qty');
        var disc = once>0 ? Math.round((once-sub)/once*100) : 0, save = once - sub;
        var mb=root.querySelector('[data-mbadge]'); if(mb){ if(disc>0){ mb.textContent='−'+disc+'%'; mb.style.display=''; } else { mb.style.display='none'; } }
        // Options : prix ramené au mois (durée / 30 j) ; le total de la cure reste
        // affiché en dessous et sur le bouton d'ajout au panier.
        var months = days/30;
        function pm(total){ return eur(Math.round(total/months)); }
        function billed(total){ return months>1 ? ('<span class="care-pv3__soit">soit </span>'+eur(total)+' / '+mlabel(days)) : (pd(total,days)+' /jour'); }
        var mnow=root.querySelector('[data-mnow]');
        if(mnow) mnow.innerHTML = pm(sub) + '<small> /mois</small>' + (save>0 ? '<small class="care-pv3__modewas"> <s>'+pm(once)+'</s></small>' : '');
        var msub=root.querySelector('[data-msub]'); if(msub) msub.innerHTML = billed(sub);
        var onow=root.querySelector('[data-onow]'); if(onow) onow.innerHTML = pm(once) + '<small> /mois</small>';
        var osub=root.querySelector('[data-osub]'); if(osub) osub.innerHTML = billed(once);
        modes.forEach(function(el){ el.classList.toggle('is-on', el.getAttribute('data-mode')===mode); });
        var isSub = mode==='sub';
        if(kit){
          // On n'agit sur l'ouverture qu'au changement de mode : sinon un changement
          // de durée rouvrirait un panneau que le client vient de replier à la main.
          var modeChanged = mode !== lastMode;
          if(isSub){
            kit.classList.remove('is-locked');
            if(modeChanged) kit.classList.add('is-open');
            if(kittitle) kittitle.textContent=kit.getAttribute('data-title-on')||'Vos cadeaux au fil de votre abonnement 🎁';
            if(kitsub) kitsub.textContent=kit.getAttribute('data-sub-on')||'Un cadeau offert à chaque livraison';
            if(kitcta) kitcta.innerHTML='Voir '+chev;
          } else {
            kit.classList.add('is-locked'); kit.classList.remove('is-open');
            if(kittitle) kittitle.textContent=kit.getAttribute('data-title-off')||'Vos cadeaux à débloquer';
            if(kitsub) kitsub.textContent=kit.getAttribute('data-sub-off')||'Un cadeau à chaque livraison, avec l’abonnement';
            if(kitcta) kitcta.textContent='Débloquer';
          }
        }
        if(qtyInput) qtyInput.value = qty;
        if(spInput){
          if(isSub && plan){ spInput.value = plan; spInput.removeAttribute('disabled'); }
          else { spInput.value=''; spInput.setAttribute('disabled','disabled'); }
        }
        if(atc){
          atc.textContent = isSub ? (atcBase + ' · ' + eur(sub)) : ('Ajouter au panier · '+eur(once));
        }
        if(ship){
          // Stock suivi à 0 (vente continuée en rupture) : on n'annonce ni stock ni date.
          var stock = ship.getAttribute('data-stock'), inStock = stock === '' || stock === null || +stock > 0;
          ship.hidden = !inStock;
          ship.innerHTML = inStock ? '<span class="care-pv3__dot" aria-hidden="true"></span><span>En stock, livraison prévue le <b>'+delivLabel()+'</b></span>' : '';
        }
        // sync barre sticky bas : elle reflète le mode coché, sinon elle annoncerait
        // un prix d'abonnement à quelqu'un qui a choisi l'achat unique.
        var sShown = isSub ? sub : once;
        var sName=document.getElementById('pv2-sticky-name'); if(sName) sName.textContent = mlabel(days)+(isSub && disc>0 ? ' · −'+disc+'%' : '');
        var sDay=document.getElementById('pv2-sticky-day'); if(sDay) sDay.textContent = pd(sShown, days)+' /jour';
        var sBtn=document.getElementById('pv2-sticky-btn'); if(sBtn) sBtn.textContent = 'Ajouter au panier · '+eur(sShown);
        renderMenu();
        lastMode = mode;
      }
      durs.forEach(function(el){ el.addEventListener('click', function(e){ e.preventDefault(); dur=+el.getAttribute('data-dur'); render(); }); });
      modes.forEach(function(el){ el.addEventListener('click', function(e){ e.preventDefault(); mode=el.getAttribute('data-mode'); render(); }); });
      if(kithead){ kithead.addEventListener('click', function(e){ e.preventDefault(); if(kit.classList.contains('is-locked')){ mode='sub'; render(); } else { kit.classList.toggle('is-open'); } }); }
      // Sticky : dropdown des durées (abonnement uniquement) + CTA
      var kSel=document.getElementById('pv2-sticky-sel');
      var kMenu=document.getElementById('pv2-sticky-menu');
      var kBtn=document.getElementById('pv2-sticky-btn');
      function renderMenu(){
        if(!kMenu) return;
        kMenu.innerHTML='';
        var isSub = mode==='sub';
        durs.forEach(function(el){
          var d=+el.getAttribute('data-dur'), s2=+el.getAttribute('data-sub'), o2=+el.getAttribute('data-once');
          var dc=o2>0?Math.round((o2-s2)/o2*100):0;
          var shown = isSub ? s2 : o2;
          var opt=document.createElement('button'); opt.type='button'; opt.className='care-pv2__stickyopt';
          opt.innerHTML='<span class="care-pv2__stickyoptname">'+mlabel(d)+(isSub && dc>0?' · −'+dc+'%':'')+'</span><span class="care-pv2__stickyoptday">'+eur(shown)+'</span>';
          opt.addEventListener('click', function(ev){ ev.stopPropagation(); dur=d; render(); kMenu.hidden=true; if(kSel) kSel.classList.remove('is-open'); });
          kMenu.appendChild(opt);
        });
      }
      if(kMenu){ kMenu.hidden=true; }
      if(kSel && kMenu){
        kSel.addEventListener('click', function(ev){ ev.stopPropagation(); var willOpen=kMenu.hidden; kMenu.hidden=!willOpen; kSel.classList.toggle('is-open', willOpen); });
        document.addEventListener('click', function(){ kMenu.hidden=true; if(kSel) kSel.classList.remove('is-open'); });
      }
      if(kBtn){ kBtn.addEventListener('click', function(){ if(atc) atc.click(); }); }
      render();
    });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initV3); } else { initV3(); }
  document.addEventListener('shopify:section:load', initV3);
})();
